import type { CustomField, CustomFieldsResponse } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchCustomFields(context: ApiContext, entityType?: string | string[]): Promise<CustomFieldsResponse> {
  const types = Array.isArray(entityType) ? entityType : entityType ? [entityType] : []
  const params = types.map((type) => `entity_type[]=${encodeURIComponent(type)}`).join("&")
  return apiContextFetch<CustomFieldsResponse>(context, `custom_fields${params ? `?${params}` : ""}`)
}

export function fetchCustomField(context: ApiContext, id: string) {
  return apiContextFetch<{ custom_field: CustomField }>(context, `custom_fields/${id}`)
}

export function createCustomField(context: ApiContext, customField: Partial<CustomField>) {
  return apiContextFetch<{ custom_field: CustomField }>(context, `custom_fields`, {
    method: "POST",
    body: JSON.stringify({ custom_field: customField }),
  })
}

export function updateCustomField(context: ApiContext, id: string, customField: Partial<CustomField>) {
  return apiContextFetch<{ custom_field: CustomField }>(context, `custom_fields/${id}`, {
    method: "PUT",
    body: JSON.stringify({ custom_field: customField }),
  })
}

export function deleteCustomField(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `custom_fields/${id}`, {
    method: "DELETE",
  })
}

export function createAiFill(
  context: ApiContext,
  customFieldId: string,
  params: { prompt: string; overwrite: boolean; entity_types: string[] }
) {
  return apiContextFetch<void>(context, `custom_fields/${customFieldId}/ai_fill`, {
    method: "POST",
    body: JSON.stringify({ ai_fill: params }),
  })
}

export function reorderCustomFields(context: ApiContext, entityType: string, fieldIds: string[]) {
  return apiContextFetch<void>(context, `custom_field_orders/${entityType}`, {
    method: "PUT",
    body: JSON.stringify({ custom_field_order: { field_ids: fieldIds } }),
  })
}
